/** 时段-到达率曲线模型（设计文档 traffic/traffic-profile.ts）。 */
import type { TrafficSegment } from '../config-schema';

export interface TrafficProfile {
  readonly segments: readonly TrafficSegment[];
}

/** 覆盖区间 [startMs, endMs]（毫秒）。 */
export function profileBoundsMs(profile: TrafficProfile): { startMs: number; endMs: number } {
  let startMs = Infinity;
  let endMs = -Infinity;
  for (const s of profile.segments) {
    const a = s.startSec * 1000;
    const b = s.endSec * 1000;
    if (a < startMs) startMs = a;
    if (b > endMs) endMs = b;
  }
  if (!Number.isFinite(startMs)) {
    startMs = 0;
    endMs = 0;
  }
  return { startMs, endMs };
}
